import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/brand@1x.png'
import _imports_1 from '../../../assets/brand@2x.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0a9cdc7a")

_pushScopeId("data-v-0a9cdc7a")
const _hoisted_1 = _imports_1
const _hoisted_2 = {
  key: 0,
  class: "skuinfo-container"
}
const _hoisted_3 = { class: "skuinfo-title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "skuinfo-bottom" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container-decorator header" }, null, -1)
const _hoisted_6 = { class: "sku-container-main" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "padding padding-left" }, null, -1)
const _hoisted_8 = { class: "container-center" }
const _hoisted_9 = { class: "section-info" }
const _hoisted_10 = { class: "title-value" }
const _hoisted_11 = {
  key: 0,
  class: "section-info"
}
const _hoisted_12 = { class: "info-label" }
const _hoisted_13 = { class: "info-value" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "brand-container" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "brand-pic",
    src: _imports_0,
    alt: "叮咚买菜商标",
    srcset: _hoisted_1
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "padding padding-right" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "container-decorator bottom" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.baseInfo.moduleName != '基本信息')
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.baseInfo.moduleName), 1),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.shoppingTitle), 1)
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseInfo.detailVOS, (item, index) => {
          return (_openBlock(), _createBlock(_Fragment, { key: index }, [
            (item.fieldName != _ctx.shoppingTitleKey)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _createVNode("label", _hoisted_12, _toDisplayString(item.fieldName) + "：", 1),
                  _createVNode("label", _hoisted_13, [
                    _createTextVNode(_toDisplayString(item.fieldContent) + " ", 1 /* TEXT */),
                    (item.fieldCode == 'PROCESS_TEMPERATURE')
                      ? (_openBlock(), _createBlock("span", _hoisted_14, "°C"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */)),
        _hoisted_15
      ]),
      _hoisted_16
    ]),
    _hoisted_17
  ], 64 /* STABLE_FRAGMENT */))
})